import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function MentorDefault({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 144"
      xmlSpace="preserve"
    >
      <g id="hébé" />
      <g id="pistis" />
      <g id="ponos">
        <g id="default_5_">
          <ellipse fill="#A6E3F9" cx="72" cy="72" rx="72" ry="71.998" />
          <g>
            <defs>
              <ellipse id="SVGID_23_" cx="72" cy="72.004" rx="72" ry="71.998" />
            </defs>
            <clipPath id="SVGID_2_">
              <use xlinkHref="#SVGID_23_" overflow="visible" />
            </clipPath>
            <g clipPath="url(#SVGID_2_)">
              <path fill="#42291C" d="M50.014,58.659c0.468,6.161-4.148,11.534-10.308,12.002c-6.161,0.468-11.534-4.148-12.002-10.308 c-0.468-6.161,4.148-11.534,10.309-12.002C44.174,47.883,49.547,52.498,50.014,58.659z" />

              <ellipse transform="matrix(0.2207 -0.9753 0.9753 0.2207 -8.5291 78.4426)" fill="#42291C" cx="44.822" cy="44.559" rx="14.453" ry="14.453" />
              <path fill="#42291C" d="M84.567,58.563l-3.771,0.286l-1.932-25.452l3.771-0.286c7.028-0.533,13.159,4.732,13.692,11.76l0,0 C96.861,51.899,91.595,58.03,84.567,58.563z" />
              <path fill="#42291C" d="M56.195,81.77l-9.791,0.743c-5.005,0.38-9.37-3.37-9.75-8.375l-0.811-10.691l18.854-1.431L56.195,81.77z" />
              <path fill="#42291C" d="M83.323,56.954L72.691,57.76l-2.486-32.753l9.589-0.728c6.006-0.456,11.244,4.044,11.7,10.05 l0.914,12.045C92.821,51.805,88.753,56.542,83.323,56.954z" />

              <ellipse transform="matrix(0.9079 -0.4192 0.4192 0.9079 -9.695 27.2687)" fill="#42291C" cx="57.213" cy="35.699" rx="16.607" ry="16.607" />
              <path fill="#00AFEC" d="M77.524,110.826c-6.343,4.166-8.107,12.686-3.941,19.029c0.334,0.508,0.705,0.975,1.091,1.424 l-0.011,0.008l37.834,43.968l15.907-12.005l-31.85-48.484C92.387,108.424,83.867,106.659,77.524,110.826z" />
              <circle fill="#00AFEC" cx="84.684" cy="122.466" r="14.136" />
              <path fill="#00AFEC" d="M98.744,123.12l-3.659,79.075H44.518l-20.896-83.042c-1.382-5.493,2.771-10.822,8.436-10.822h52.565 C92.686,108.33,99.117,115.065,98.744,123.12z" />
              <path fill="#00AFEC" d="M42.027,111.974c-5.795-5.231-14.734-4.775-19.966,1.02c-0.419,0.464-0.788,0.955-1.134,1.455 l-0.011-0.009l-33.941,49.079l16.082,12.715l39.991-44.296C48.279,126.144,47.822,117.205,42.027,111.974z" />
              <path fill="#283042" d="M101.061,58.592c-0.012,0.009-0.012,0.009-0.012,0.009" />
              <path fill="#FDC9A3" d="M53.694,110.232c1.065,6.52,7.213,10.941,13.733,9.876s10.942-7.213,9.877-13.733c-1.065-6.52-7.213-10.941-13.733-9.876C57.051,97.564,52.629,103.712,53.694,110.232z" />
              <polygon fill="#FDC9A3" points="77.304,106.376 53.694,110.232 48.945,81.161 49.638,81.047 72.555,77.304" />
              <path fill="#FDC9A3" d="M63.969,28.39l-1.836,0.3c-11.72,1.914-19.669,12.967-17.755,24.686l6.529,39.974l22.229-3.631c11.163-1.823,18.735-12.351,16.911-23.514l-3.528-21.597C84.771,33.903,74.674,26.642,63.969,28.39z" />
              <path fill="#0E0E11" d="M77.352,55.212c-0.219,0-0.405-0.169-0.422-0.391c-0.017-0.233,0.157-0.437,0.39-0.455l5.737-0.436c0.229-0.019,0.437,0.157,0.455,0.39c0.017,0.233-0.157,0.437-0.39,0.455l-5.737,0.436C77.375,55.211,77.363,55.212,77.352,55.212z" />
              <path fill="#0E0E11" d="M62.525,55.848c-0.223,0-0.409-0.173-0.423-0.398c-0.014-0.233,0.164-0.434,0.397-0.448l6.227-0.378 c0.255-0.007,0.435,0.164,0.448,0.397c0.014,0.233-0.164,0.434-0.397,0.448l-6.227,0.378 C62.541,55.848,62.533,55.848,62.525,55.848z" />

              <ellipse transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.3031 3.7598)" fill="#0E0E11" cx="65.872" cy="61.203" rx="1.621" ry="2.092" />

              <ellipse transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.2382 4.5359)" fill="#0E0E11" cx="79.844" cy="60.425" rx="1.621" ry="2.092" />
              <path fill="#42291C" d="M89.677,46.286l-21.474,1.63C59.451,48.58,51.791,42,51.127,33.248 c-0.316-4.165,2.804-7.798,6.969-8.114s7.798,2.804,8.114,6.969c0.033,0.435,0.413,0.762,0.849,0.729l21.474-1.63L89.677,46.286z" />
              <path fill="#42291C" d="M78.999,26.654c0.318,4.187-2.819,7.839-7.006,8.157s-7.839-2.819-8.157-7.006 c-0.318-4.187,2.819-7.839,7.006-8.157C75.029,19.33,78.681,22.466,78.999,26.654z" />
              <path fill="#42291C" d="M50.608,31.566l3.554-0.27l2.24,29.518c0.25,3.297-2.22,6.173-5.517,6.423L35.177,68.43l-1.318-17.363 C33.099,41.056,40.598,32.326,50.608,31.566z" />
              <path fill="#42291C" d="M81.091,39.352l-10.684,0.811c-4.165,0.316-7.798-2.804-8.114-6.969 c-0.316-4.165,2.804-7.798,6.969-8.114l10.683-0.811c4.165-0.316,7.798,2.804,8.114,6.969 C88.377,35.403,85.256,39.036,81.091,39.352z" />
              <path fill="#FDC9A3" d="M45.051,69.455l4.88-0.793l-0.791-4.87c-0.437-2.689-2.976-4.514-5.671-4.076l0,0 c-2.695,0.438-4.526,2.974-4.089,5.663l0,0C39.817,68.069,42.356,69.894,45.051,69.455z" />
              <path fill="#42291C" d="M91.487,80.84c0.853,4.039-2.31,8.026-6.948,8.742l-15.074,1.195 c-8.953,1.384-17.198-3.885-18.417-11.768l-1.435-12.304l3.922-5.027c0,0,1.649,5.828,2.373,6.993 c1.28,2.059,4.053,3.51,7.746,2.939l26.639-3.036L91.487,80.84z" />
              <path fill="#FFFFFF" d="M68.877,74.605c0.369,3.282,3.33,5.644,6.612,5.275c3.282-0.369,5.644-3.33,5.275-6.612L68.877,74.605z" />
            </g>
            <g clipPath="url(#SVGID_2_)">

              <line fill="none" stroke="#0E0E11" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="70" y1="60.936" x2="75.913" y2="60.579" />

              <circle fill="none" stroke="#0E0E11" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="66.012" cy="61.158" r="3.994" />

              <circle fill="none" stroke="#0E0E11" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="80.066" cy="60.375" r="3.994" />
            </g>
          </g>
        </g>
      </g>
      <g id="TITLE" />
    </svg>
  );
}

export default MentorDefault;
